import React from 'react'

const ProgressBar = ({ hands, completedHands }) => {
  const length = hands.length
  const takenLength = Object.keys(completedHands || {}).length || 0
  const percentage = Math.round((takenLength / length) * 100)

  if (!hands || !takenLength) return null

  return (
    <div className="ClearTheCharts__progress-bar">
      {!!percentage && (
        <div
          style={{
            // background: 'linear-gradient(to left, #0085FF, #2196f3)',
            background: `linear-gradient(
              90deg,
              rgba(34, 193, 195, 1) 0%,
              rgba(45, 63, 253, 1) 100%
            )`,
            // boxShadow: '0 3px 3px -5px #0085FF, 0 2px 5px #0085FF',
            borderRadius: '20px',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            width: `${percentage}%`,
            opacity: 1,
            transition: '1s ease 0.3s',
          }}
        ></div>
      )}
      <p
        style={{
          color: 'white',
          fontSize: '16px',
          position: 'absolute',
          left: 15,
          top: '50%',
          transform: 'translateY(-50%)',
          fontWeight: '500',
        }}
      >
        {percentage}%
      </p>
    </div>
  )
}

export default ProgressBar
